module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "page-article"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('clearfix', {
    attrs: {
      "biggest": true,
      "bootstrap": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 content og-bg-dark"
  }, [_c('h3', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editingTitle),
      expression: "!editingTitle"
    }],
    on: {
      "click": _vm.editTitle
    }
  }, [_vm._v(_vm._s(_vm.article.title))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editingTitle),
      expression: "editingTitle"
    }],
    staticClass: "edit-box"
  }, [_c('label', {
    attrs: {
      "for": "field-title"
    }
  }, [_vm._v("title: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.title),
      expression: "article.title"
    }],
    staticClass: "article-field",
    attrs: {
      "id": "field-title",
      "placeholder": "Article title:",
      "type": "text"
    },
    domProps: {
      "value": (_vm.article.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.article, "title", $event.target.value)
      }
    }
  }), _vm._v("\n           "), _c('b-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.creatingNew),
      expression: "!creatingNew"
    }],
    attrs: {
      "size": 'sm',
      "variant": 'secondary'
    },
    on: {
      "click": _vm.saveTitle
    }
  }, [_vm._v("save")])], 1)]), _vm._v(" "), _c('clearfix', {
    attrs: {
      "biggest": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 content og-bg-light"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editingIntro),
      expression: "!editingIntro"
    }],
    staticClass: "article-intro",
    domProps: {
      "innerHTML": _vm._s(_vm.article.intro)
    },
    on: {
      "click": _vm.editIntro
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editingIntro),
      expression: "editingIntro"
    }]
  }, [_c('quill-editor', {
    attrs: {
      "options": _vm.introEditorOptions
    },
    on: {
      "change": _vm.introChange
    },
    model: {
      value: (_vm.article.intro),
      callback: function($$v) {
        _vm.$set(_vm.article, "intro", $$v)
      },
      expression: "article.intro"
    }
  }), _vm._v(" "), _c('br'), _c('b-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.creatingNew),
      expression: "!creatingNew"
    }],
    attrs: {
      "size": 'sm',
      "variant": 'secondary'
    },
    on: {
      "click": _vm.saveIntro
    }
  }, [_vm._v("save intro")])], 1), _vm._v(" "), _c('clearfix', {
    attrs: {
      "wide": true
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editingContent),
      expression: "!editingContent"
    }],
    staticClass: "article-content",
    domProps: {
      "innerHTML": _vm._s(_vm.article.content)
    },
    on: {
      "click": _vm.editContent
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editingContent),
      expression: "editingContent"
    }]
  }, [_c('quill-editor', {
    attrs: {
      "options": _vm.contentEditorOptions
    },
    on: {
      "change": _vm.contentChange
    },
    model: {
      value: (_vm.article.content),
      callback: function($$v) {
        _vm.$set(_vm.article, "content", $$v)
      },
      expression: "article.content"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.creatingNew),
      expression: "!creatingNew"
    }],
    attrs: {
      "size": 'sm',
      "variant": 'secondary'
    },
    on: {
      "click": _vm.saveContent
    }
  }, [_vm._v("save content")]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.creatingNew),
      expression: "creatingNew"
    }],
    attrs: {
      "size": 'large',
      "variant": 'secondary'
    },
    on: {
      "click": _vm.saveArticle
    }
  }, [_vm._v("save article")])], 1)], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-631f7840"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/blog/BlogArticle.vue
// module id = 1209
// module chunks = 1